<template>
  <div :id="id" class="h-full w-full"></div>
</template>
<script>
export default {
  props: ['id', 'cameraIndexCode'],
  data() {
    return {
      oWebControl: null, // 播放器实例
      pubKey: '',
      initCount: 0, // 重连次数
      showVideo: false,
      timer: null,
    }
  },
  computed: {
    // 相机相关配置
    cameraConfig() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management"].config.cameraConfig'
      )
    },
  },
  mounted() {
    // 设置播放容器的宽高并监听窗口大小变化
    window.addEventListener('resize', this.resizeVideo)
    this.initVideoView()
  },
  watch: {
    cameraIndexCode() {
      this.initVideoView()
    }
  },
  methods: {
    resizeVideo() {
      const node = document.getElementById(this.id)
      if (node.childNodes.length > 0) {
        node.removeChild(node.childNodes[0])
      }
      if (this.showVideo) {
        if (this.timer) clearInterval(this.timer)
        this.timer = setTimeout(() => {
          let height = document.getElementById(this.id).offsetHeight - 20
          let width = document.getElementById(this.id).offsetWidth
          this.oWebControl.JS_Resize(width, height)
          this.setWndCover()
        }, 100)
      }
    },
    // 设置窗口裁剪，当因滚动条滚动导致窗口需要被遮住的情况下需要JS_CuttingPartWindow部分窗口
    setWndCover() {
      let iWidth = $(window).width()
      let iHeight = $(window).height()
      console.log(iWidth, iHeight)
      let oDivRect = $(`#${this.id}`)
        .get(0)
        .getBoundingClientRect()
      console.log(oDivRect, $(this.id).get(0))
      let iCoverLeft = oDivRect.left < 0 ? Math.abs(oDivRect.left) : 0
      let iCoverTop = oDivRect.top < 0 ? Math.abs(oDivRect.top) : 0
      let iCoverRight = oDivRect.right - iWidth > 0 ? Math.round(oDivRect.right - iWidth) : 0
      let iCoverBottom = oDivRect.bottom - iHeight > 0 ? Math.round(oDivRect.bottom - iHeight) : 0

      iCoverLeft = iCoverLeft > 1000 ? 1000 : iCoverLeft
      iCoverTop = iCoverTop > 600 ? 600 : iCoverTop
      iCoverRight = iCoverRight > 1000 ? 1000 : iCoverRight
      iCoverBottom = iCoverBottom > 600 ? 600 : iCoverBottom

      this.oWebControl.JS_RepairPartWindow(0, 0, 1001, 600) // 多1个像素点防止还原后边界缺失一个像素条
      if (iCoverLeft != 0) {
        this.oWebControl.JS_CuttingPartWindow(0, 0, iCoverLeft, 600)
      }
      if (iCoverTop != 0) {
        this.oWebControl.JS_CuttingPartWindow(0, 0, 1001, iCoverTop) // 多剪掉一个像素条，防止出现剪掉一部分窗口后出现一个像素条
      }
      if (iCoverRight != 0) {
        this.oWebControl.JS_CuttingPartWindow(1000 - iCoverRight, 0, iCoverRight, 600)
      }
      if (iCoverBottom != 0) {
        this.oWebControl.JS_CuttingPartWindow(0, 600 - iCoverBottom, 1000, iCoverBottom)
      }
    },
    // 判断播放器是否销毁
    initVideoView() {
      if (this.cameraIndexCode) {
        if (this.oWebControl == null) {
          this.initVideoPlugin()
        } else {
          this.destroyedView()
          setTimeout(this.initVideoView, 1000)
        }
      }
    },
    // 创建监控播放实例
    initVideoPlugin() {
      const _this = this
      _this.oWebControl = new WebControl({
        szPluginContainer: _this.id, // 指定容器id
        iServicePortStart: 15900, // 指定起止端口号，建议使用该值
        iServicePortEnd: 15909,
        szClassId: '23BF3B0A-2C56-4D97-9C03-0CB103AA8F11', // 用于IE10使用ActiveX的clsid
        cbConnectSuccess: function() {
          // 创建WebControl实例成功
          console.log('创建WebControl实例成功')
          _this.oWebControl
            .JS_StartService('window', {
              // WebControl实例创建成功后需要启动服务
              dllPath: './VideoPluginConnect.dll', // 值"./VideoPluginConnect.dll"写死
            })
            .then(
              function() {
                // 启动插件服务成功
                console.log('启动插件服务成功')
                _this.oWebControl.JS_SetWindowControlCallback({
                  // 设置消息回调
                  cbIntegrationCallBack: _this.cbIntegrationCallBack,
                })
                let height = document.getElementById(_this.id).offsetHeight - 20
                let width = document.getElementById(_this.id).offsetWidth
                _this.oWebControl.JS_CreateWnd(_this.id, width, height).then(function() {
                  //JS_CreateWnd创建视频播放窗口，宽高可设定
                  _this.init() // 创建区域监控播放实例成功后初始化
                })
              },
              function() {
                // 启动插件服务失败
              }
            )
        },
        cbConnectError: function() {
          // 创建WebControl实例失败
          _this.oWebControl = null
          WebControl.JS_WakeUp('VideoWebPlugin://') // 程序未启动时执行error函数，采用wakeup来启动程序
          _this.initCount++
          if (_this.initCount < 3) {
            setTimeout(function() {
              _this.$message.warning('插件未启动，正在尝试启动，请稍候...')
              _this.initVideoPlugin()
            }, 3000)
          } else {
            // 父组件提供下载弹框，避免组件触发多次下载弹框
            _this.$emit('downloadDialog')
          }
        },
        cbConnectClose: function(bNormalClose) {
          // 异常断开：bNormalClose = false
          // JS_Disconnect正常断开：bNormalClose = true
          if (!bNormalClose) {
            _this.$message.error('视屏链接异常中断!')
          }
          _this.oWebControl = null
        },
      })
    },
    init() {
      const _this = this
      _this.getPubKey(function() {
        // 请自行修改以下变量值
        let ip = _this.cameraConfig?.ip || '11.72.224.100' //平台IP地址，必填
        let port = _this.cameraConfig?.port || 80 //平台端口，若启用HTTPS协议，默认443
        let appkey = _this.cameraConfig?.key || '25890601' //平台提供的appkey，必填
        let secret = _this.setEncrypt(_this.cameraConfig?.secret || 'gyJNKg8r8oU3UI6sQGEr') //平台提供的secret，必填
        let playMode = 0 //初始播放模式：0-预览，1-回放
        let snapDir = 'D:\\SnapDir' //抓图存储路径
        let videoDir = 'D:\\VideoDir' //紧急录像或录像剪辑存储路径
        let layout = '1x1' //playMode指定模式的布局
        let enableHTTPS = 1 //是否启用HTTPS协议与平台交互，这里总是填1
        let encryptedFields = 'secret' //加密字段，默认加密领域为secret
        let showToolbar = 0 //是否显示工具栏，0-不显示，非0-显示
        let showSmart = 1 //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
        let buttonIDs = '' //自定义工具条按钮
        let reconnectTimes = 0 // 断流后无限次重连
        // 请自行修改以上变量值
        _this.oWebControl
          .JS_RequestInterface({
            funcName: 'init',
            argument: JSON.stringify({
              appkey: appkey, //API网关提供的appkey
              secret: secret, //API网关提供的secret
              ip: ip, //API网关IP地址
              playMode: playMode, //播放模式（决定显示预览还是回放界面）
              port: port, //端口
              snapDir: snapDir, //抓图存储路径
              videoDir: videoDir, //紧急录像或录像剪辑存储路径
              layout: layout, //布局
              enableHTTPS: enableHTTPS, //是否启用HTTPS协议
              encryptedFields: encryptedFields, //加密字段
              showToolbar: showToolbar, //是否显示工具栏
              showSmart: showSmart, //是否显示智能信息
              buttonIDs: buttonIDs, //自定义工具条按钮
              reconnectTimes: reconnectTimes, // 断流后无限次重连
            }),
          })
          .then(function(oData) {
            let height = document.getElementById(_this.id).offsetHeight - 20
            let width = document.getElementById(_this.id).offsetWidth
            _this.oWebControl.JS_Resize(width, height) // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
            _this.startPreview()
          })
      })
    },
    // 监控视频预览功能
    startPreview() {
      let _this = this
      let cameraIndexCode = _this.cameraIndexCode //获取输入的监控点编号值，必填
      let streamMode = 0 //主子码流标识：0-主码流，1-子码流
      let transMode = 1 //传输协议：0-UDP，1-TCP
      let gpuMode = 0 //是否启用GPU硬解，0-不启用，1-启用
      let wndId = -1 //播放窗口序号（在2x2以上布局下可指定播放窗口）

      cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, '')
      cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, '')

      _this.oWebControl.JS_RequestInterface({
        funcName: 'startPreview',
        argument: JSON.stringify({
          cameraIndexCode: cameraIndexCode, //监控点编号
          streamMode: streamMode, //主子码流标识
          transMode: transMode, //传输协议
          gpuMode: gpuMode, //是否开启GPU硬解
          wndId: wndId, //可指定播放窗口
        }),
      })
      this.showVideo = true
    },
    //停止监控预览
    stopPreview() {
      this.oWebControl.JS_RequestInterface({
        funcName: 'stopPreview',
      })
    },
    // 摧毁播放器
    destroyedView() {
      if (this.oWebControl != null) {
        this.stopPreview()
        this.oWebControl.JS_HideWnd() // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
        this.oWebControl.JS_Disconnect().then(
          function() {
            // 断开与插件服务连接成功
          },
          function() {
            // 断开与插件服务连接失败
          }
        )
      }
    },
    // 获取监控公钥
    getPubKey(callback) {
      this.oWebControl
        .JS_RequestInterface({
          funcName: 'getRSAPubKey',
          argument: JSON.stringify({
            keyLength: 1024,
          }),
        })
        .then((oData) => {
          if (oData.responseMsg.data) {
            this.pubKey = oData.responseMsg.data
            callback()
          }
        })
    },
    // 监控RSA加密
    setEncrypt(value) {
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(this.pubKey)
      return encrypt.encrypt(value)
    },
    // 设置窗口回调
    setCallBack() {
      this.oWebControl.JS_SetWindowControlCallback({
        cbIntegrationCallBack: this.cbIntegrationCallBack,
      })
    },
    // 推送消息
    cbIntegrationCallBack(oData) {
      // type =7  播放窗口双击事件
      if (oData.responseMsg.type === 7) {
        // 全屏
        this.oWebControl.JS_RequestInterface({
          funcName: 'setFullScreen',
        })
        this.$emit('videoFullScreen', {
          id: this.id,
          isFullScreen: true,
        })
      } else if (oData.responseMsg.type === 5) {
        /**
         * type = 5  插件窗口是否全屏
         *  向父组件传递是否退出全屏信息  控制其他播放器的显示和隐藏
         * result = 1024 进入全屏 result = 1025 退出全屏
         */
        let isFullScreen = oData.responseMsg.msg.result === 1025 ? false : true
        this.$emit('videoFullScreen', {
          id: this.id,
          isFullScreen,
        })
      } else if(oData.responseMsg.type === 2) {
        if(oData.responseMsg.msg.result === 769) {
          this.hideWnd()
          let height = document.getElementById(this.id).offsetHeight - 20
          let width = document.getElementById(this.id).offsetWidth
          this.oWebControl.JS_CreateWnd(this.id, width, height).then(()=> {
            this.init()
          })
        }else if(oData.responseMsg.msg.result === 768) {
          this.showWnd()
        }
      }
      console.log(oData)
    },
    // 隐藏窗口
    hideWnd() {
      this.oWebControl.JS_HideWnd()
    },
    // 显示窗口
    showWnd() {
      this.oWebControl.JS_ShowWnd()
    },
  },
  beforeDestroy() {
    this.destroyedView()
    clearInterval(this.timer)
  },
}
</script>
